import SelectInput from 'components/SelectInput';
import React, { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

const Setting = ({ open }: { open: boolean }) => {
  const { register, setValue } = useFormContext();

  const units = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

  useEffect(() => {
    if(open){
      setValue('amount', 1);
      // unit is a multiplier (Math.pow(1000, i)); seed to 1 (the default 'h/s'
      // option) so an untouched dropdown doesn't store alert_limit = amount * 0.
      setValue('unit', 1);
    }
  }, [open]);

  return (
    <>
      <input type='number' {...register('amount', { valueAsNumber: true })} />
      <SelectInput
        value={0}
        options={units.map((u: string, i: number) => ({
          isDefault: 0 === i,
          name: `${u}h/s`,
          value: Math.pow(1000, i),
        }))}
        onChange={(value) => {
          setValue('unit', value);
        }}
      />
    </>
  );
};

export default Setting;
